import { theme } from '../theme';
export const tokens = {
    Drawer: {
        padding: theme.spaces.x12,
        zIndex: theme.zLayer.m,
        Header: {
            height: theme.sizes.x32,
            background: theme.colors.gray25,
            borderColor: theme.colors.gray200
        },
        Content: {
            background: theme.colors.white
        },
        Icon: {
            color: theme.colors.gray500
        }
    },
    DrawerTabHeader: {
        Tab: {
            active: {
                backgroundColor: theme.colors.gray200
            }
        },
        Separator: {
            height: theme.sizes.x24
        }
    }
};
